'use client';
import useSWR from 'swr';
import { apiOslogCrud } from '../helpers/oslogFormatEndpoint';
import FilterBuilder from '../utils/filterBuilder';
import { useMemo } from 'react';

const endpoint = 'user-pod';
const api = apiOslogCrud(endpoint);

const fetcher = async ([url, payload]) => {
  const p = typeof payload === 'string' ? JSON.parse(payload) : payload;
  const response = await api.search(p);
  return response;
};
export const usePodList = (page = 0, rowsPerPage = 100, selectedCompanies = [], searchField = 'username', searchQuery = '') => {
  const start = page * rowsPerPage;

  const companies = (selectedCompanies || [])
    .map((c) => (typeof c === 'object' ? c.value : c))
    .filter((v) => v !== 'all' && v != null && v !== '')
    .join(',');

  const payload = useMemo(() => {
    const builder = new FilterBuilder()
      .setPaging(start, rowsPerPage)
      .addJoin('company', ['name'])
      .addJoin('role', ['name'])
      .setOrder(['id'], false);

    if (companies) {
      if (companies.includes(',')) {
        builder.in('company_id', companies);
      } else {
        builder.equal('company_id', companies);
      }
    }

    if (searchQuery && searchQuery.trim() !== '') {
      const val = searchQuery.trim();
      if (searchField === 'role_name') {
        builder.like('role_name', val);
      } else if (searchField === 'all') {
        builder.like('username', val);
      } else if (searchField) {
        builder.like(searchField, val);
      }
    }

    return builder.build();
  }, [start, rowsPerPage, companies, searchField, searchQuery]);

  const key = useMemo(() => [`/${endpoint}/search`, JSON.stringify(payload)], [payload]);

  const {
    data,
    error,
    isValidating,
    mutate: refetch
  } = useSWR(key, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
    keepPreviousData: true,
    revalidateOnMount: true
  });

  const responseData = data?.data ?? data;
  const rows = Array.isArray(responseData) ? responseData : (responseData?.data ?? []);

  const totalRecord = data?.data?.totalRecord ?? data?.totalRecord ?? (Array.isArray(rows) ? rows.length : 0);

  return {
    data: rows,
    isLoading: isValidating,
    isError: error,
    totalRecord,
    refetch
  };
};
